export interface Job {
    id: number,
    jobId: string,
    steamId?: bigint,
    userName?: string,
    created: Date,
    failedAt?: Date,
    jobType: JobType,
    jobParams?: string,
    comment?: string,
    errorMessage?: string
}

export interface JobsListResult{
    items: Job[],
    count: number
}

export enum JobType {
    Undefined = 0,
    PauseOnSoldItems = 1,
    OneTimeJob = 2,
    SyncGiftInventory = 3,
    UnbanAfterPenalty = 4,
    RemoveFromReserved = 5,
    SyncInventory = 6,
    OffTheMarket = 7,
    UpdateSteamLevel = 8,
    UnpauseOnSoldItems = 9,
    HandleBid = 10,
    SyncSkinStates = 11,
    HandleSellerOffers = 12,
    HandleOffer = 13,
    ExternalPurchase = 25,
    ExternalMarketSync = 26,
    ExternalMarketShowcase = 27,
    ExternalMarketAutoDisable = 28,
}

export const JobTypeDescription = {
    0: 'Не определено',
    1: 'Пауза продаж',
    2: 'Разовая задача',
    3: 'Синхронизация подарков',
    4: 'Снятие штрафного бана',
    5: 'Снятие скинов с резерва',
    6: 'Синхронизация инвентаря',
    7: 'Снятие с продажи',
    8: 'Обновление уровня в Steam',
    9: 'Снятие с паузы',
    10: 'Обработка заявок',
    11: 'Синхронизация статусов скинов',
    12: 'Групповая обработка оферов продавца',
    13: 'Обработка офера продавца по заказу',
    25: 'Выкуп у поставщика',
    26: 'Синхронизация витрины поставщика',
    27: 'Пауза или снятие витрины поставщика',
    28: 'Выключение связки: нет денег поставщика'
}